<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper *ngIf="!isLoading">
    <div id="page" class="watcher-wrapper">

        <div class="watcher-header">
            <div>
                <div class="header-text" *ngIf="watchers.length === 0 && persistentWatchers.length === 0">You aren't
                    watching for any flights</div>
                <div class="header-text" *ngIf="watchers.length + persistentWatchers.length > 0">Watching for flights
                    with these plans</div>
            </div>
            <button type="button" class="add-link" (click)="onShowAddPersistentWatcher()">
                <span class="plus">+</span>
                <span>Watcher</span>
            </button>
        </div>

        <app-alert-message *ngIf="error" type="error" mb="12px">{{ error }}</app-alert-message>

        <div class="watcher-results">

            <div class="items" *ngIf="persistentWatchers?.length > 0">
                <app-watcher-card *ngFor="let p of persistentWatchers" [watcher]="p" [persistent]="true"
                    (handleViewOptionsClick)="onClickPersistentWatcher(p)" (handleToggleStatus)="showStatusTray($event)"
                    (handleDeleteWatcher)="showDeletePersistentTray($event)"></app-watcher-card>
            </div>

            <div class="items" *ngIf="watchers?.length > 0; else emptyExact">
                <app-watcher-card *ngFor="let w of watchers" [watcher]="w" (handleViewOptionsClick)="onClickWatcher(w)"
                    (handleTogglePrivacy)="showPrivacyTray($event)"
                    (handleDeleteWatcher)="showDeleteTray($event)"></app-watcher-card>
            </div>

            <ng-template #emptyExact>
                <app-empty-state-card messageText="Chat with Agent to create specific flight watchers"></app-empty-state-card>
            </ng-template>

        </div>

    </div>
</app-page-wrapper>

<app-add-persistent-watcher *ngIf="showAddPersistent"
    (onClose)="onCloseAddPersistentWatcher()"></app-add-persistent-watcher>

<app-pop-tray *ngIf="showDelete" [header]="'Delete This Watcher?'"
    [description]="'The agent will stop watching for flights. If your plans are public, other flyers will not be able to contact you to coordinate'"
    [actions]="deleteActions">
</app-pop-tray>

<app-pop-tray *ngIf="showTogglePrivacy"
    [header]="targetFlightOption.isVisible ? 'Make Your Plans Private' : 'Maker Your Plans Public'" [description]="targetFlightOption.isVisible ? 'Other members will not see your travel plans when searching or be able to request to connect with you' :
    'Other members will be able to see your plans as an option and can request to connect'"
    [actions]="targetFlightOption.isVisible ? makePrivateActions : makePublicActions">
</app-pop-tray>

<app-pop-tray *ngIf="showStatus"
    [header]="targetPersistentWatcher?.status === 'active' ? 'Pause Watcher?' : 'Resume Watcher?'" [description]="''"
    [actions]="statusActions"></app-pop-tray>
<app-pop-tray *ngIf="showDeletePersistent" [header]="'Delete This Watcher?'"
    [description]="'This will remove the persistent watcher.'" [actions]="deletePersistentActions"></app-pop-tray>
